<template>
	<div id="index">
		<!-- 数据统计 -->
		<el-row :gutter="20">
			<el-col :span="6" v-for="(item,index) in counts" :key="index">
				<el-card class="box-card" shadow="hover">
					<div class="d-flex align-items-center" @click="toView(item.name)">
						<i style="width: 40px;height: 40px;line-height: 40px;" :class="[item.icon,item.color]"
							class=" h4 mb-0 bg-primary text-white text-center mr-3"></i>
						<div>
							<h4 class="mb-1">{{item.num}}</h4>
							<small class="text-muted">{{item.desc}}</small>
						</div>
					</div>

				</el-card>
			</el-col>
		</el-row>

		<!-- 店铺 其他统计 -->
		<el-row :gutter="20" class="mt-3">
			<!-- 左边 -->
			<el-col :span="12">
				<el-card class="box-card" style="height: 370px;" shadow="hover">
					<div slot="header" class="clearfix">
						<span>7日新增</span>
						<el-button style="float: right;padding: 3px 0;" type="text"></el-button>
					</div>
					<!-- 统计图容器 -->
					<div ref="myChart" style="width: 100%;height: 270px;">

					</div>
				</el-card>
			</el-col>
			<!-- 右边 -->


			<el-col :span="12">
				<el-card class="box-card" shadow="hover">
					<div slot="header" class="clearfix">
						<span>实时统计</span>
						<!-- <el-button style="float: right;padding: 3px 0;" type="text">查看详细</el-button> -->
					</div>

					<!-- 统计图容器 -->
					<div ref="myChart3" style="width: 100%;height: 270px;">

					</div>
				</el-card>
			</el-col>
		</el-row>


		<!-- 销售数据 与其他数据 -->
		<el-row :gutter="20" class="my-3">
			<!-- 左边 -->
			<el-col :span="12">
				<el-card class="box-card" shadow="hover">
					<div slot="header" class="clearfix">
						<span>7日活跃</span>
						<el-button style="float: right;padding: 3px 0;" type="text">每日活跃数量</el-button>
					</div>

					<!-- 统计图容器 -->
					<div ref="myChart2" style="width: 100%;height: 270px;">

					</div>
				</el-card>
			</el-col>
			<!-- 右边 -->
			<el-col :span="12">
				<el-card class="box-card" shadow="hover">
					<div slot="header" class="clearfix">
						<span>访问来源详细</span>
						<el-button style="float: right;padding: 3px 0;" type="text"></el-button>
					</div>
					<!-- <div class="media align-items-center border ">
						<span class="py-4 px-3 bg-light border-right">昨日销量</span>
						<div class="media-body">
							<div class="border-bottom pl-3 pb-2 mb-2"><span>订单量</span>12</div>
							<div class="pl-3 mt-2"><span>订单量</span>12</div>
						</div>
					</div>
				
					<div class="media align-items-center border mt-3 ">
						<span class="py-4 px-3 bg-light border-right">昨日销量</span>
						<div class="media-body">
							<div class="border-bottom pl-3 pb-2 mb-2"><span>订单量</span>12</div>
							<div class="pl-3 mt-2"><span>订单量</span>12</div>
						</div>
					</div> -->
					<el-table height="270" :data="tableData" style="width: 100%;">
						<el-table-column align="center" type="index" label="排序" width="50">
						</el-table-column>

						<el-table-column prop="url" align="center" label="来源网址">
						</el-table-column>
						<el-table-column prop="num" align="center" label="访问数量">
						</el-table-column>


					</el-table>
				</el-card>

			</el-col>
		</el-row>
	</div>
</template>

<script>
	//图形统计导入
	import common from '@/common/mixins/common.js';
	import echarts from 'echarts'
	export default {
		inject: ['layout'],
		mixins: [common],
		data() {
			return {
				timer: null, //定时器名称
				preUrl: "user/homeData", //列表地址
				tableData: [],
				shoplist: {},
				orderlist: {},
				counts: [],
				day_list: [],
				pay_money: [],
				add_num: [],
				user_num: [],
				hourData:{
					name:[],
					add:[],
					num:[]
				}
			}
		},
		filters: {
			getCol(total) {
				return `col-${12/total}`
			}
		},
		//dom渲染完毕 
		mounted() {
			//画统计图
			//this.drawLine()
			this.queryInfo();
			this.timer = setInterval(() => {
				setTimeout(this.queryInfo, 0)
			}, 1000 * 30)

		},
		beforeDestroy() {
			clearInterval(this.timer);
			this.timer = null;
		},
		methods: {
			queryInfo() {
				//do something
				this.checkHour()
			},
			
			checkHour() {
				
				this.api.post('/data/hourData', {
				}).then(res => {
					//console.log('定时器执行')
	
					this.hourData = res.data.data.list
					this.drawLine3()
					
				}).catch(err => {
					
				})
			},
			

			getListResult(e) {
				this.tableData = e.list
				this.counts = e.head_list
				this.hourData = e.hour_list

				this.shoplist = e.shop_list
				this.tableData = e.from_list
				this.orderlist = e.orderlist
				//console.log(e.shop_list)
				this.day_list = e.from_list.map(item => {
					return {
						value: item.num,
						name: item.url
					}
				})

				this.user_num = e.day_7_data.map(item => {
					return {
						product: item.date,
						'每日活跃': item.num
					}
				})
				this.add_num = e.day_7_data.map(item => {
					return {
						product: item.date,
						'每日新增': item.add_num
					}
				})
				//console.log(this.day_list)

				//画统计图
				this.drawLine()
				this.drawLine2()
				this.drawLine3()
			},
			//前往修改页面
			toView(name) {
				this.$router.push({
					name: name,

				})
			},
			drawLine() {
				//初始化echarts实例 
				//console.log(this.$refs.myChart);
				let myChart = echarts.init(this.$refs.myChart);
				// 配置参数



				myChart.setOption({
					legend: {},
					tooltip: {},
					dataset: {
						dimensions: ['product', '每日新增'],
						source: this.add_num
					},
					xAxis: {
						type: 'category'
					},
					yAxis: {},
					// Declare several bar series, each will be mapped
					// to a column of dataset.source by default.
					series: [{
						type: 'bar'
					}, ]
				})
			},
			drawLine2() {
				//初始化echarts实例 
				//console.log(this.$refs.myChart);
				let myChart = echarts.init(this.$refs.myChart2);
				// 配置参数



				myChart.setOption({
					legend: {},
					tooltip: {},
					dataset: {
						dimensions: ['product', '每日活跃'],
						source: this.user_num
					},
					xAxis: {
						type: 'category'
					},
					yAxis: {},
					// Declare several bar series, each will be mapped
					// to a column of dataset.source by default.
					series: [{
						type: 'bar'
					}, ]
				})
			},
			drawLine3() {
				//初始化echarts实例 
				//console.log(this.$refs.myChart);
				let myChart = echarts.init(this.$refs.myChart3);
				// 配置参数

				myChart.setOption({
					title: {
						text: '最近一小时新增 | 活跃'
					},
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						data: ['新增', '活跃'],
						top:"30px"
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					toolbox: {
						feature: {
							saveAsImage: {}
						}
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: this.hourData.name
					},
					yAxis: {
						type: 'value'
					},
					series: [{
							name: '新增',
							type: 'line',
							stack: '总量',
							data: this.hourData.add
						},
						{
							name: '活跃',
							type: 'line',
							stack: '总量',
							data: this.hourData.num
						}
						
					]
				})
			}
		}
	}
</script>

<style>
</style>
